import { Box, Text } from "@chakra-ui/react";
import {
  EhrName,
  EhrProvider,
  EhrWriteParams,
  PatientOverview,
  PatientOverviewV2,
  SharedStateProvider,
} from "@metriport/shared-internal";
import { ossBaseUrlCanvas } from "../../../api/api";
import {
  getResourceDiffJob,
  startResourceDiffJob,
  writeResourceToChart,
} from "../../../api/ehr/canvas";
import { useAppContext } from "../../contexts/app/index";
import useMetriportToast from "../../shared/toast";

export default function PatientPage() {
  const { state } = useAppContext();
  const toast = useMetriportToast();

  if (!state.isLoaded) {
    return null;
  }

  const { ehrPatientId, ehrPractitionerId } = state;
  if (!ehrPatientId) {
    return (
      <Box>
        <Text>No Patient</Text>
      </Box>
    );
  }

  const ehrDetails = {
    ehrPatientId,
    write: async (params: EhrWriteParams) => {
      if (!ehrPractitionerId) {
        toast.warning({
          title:
            "Practitioner ID is required. Please update your Canvas plug-in to 0.0.3 or later. If the problem persists, please reach out to support@metriport.com",
        });
        return;
      }
      await writeResourceToChart({
        ...params,
        practitionerId: ehrPractitionerId,
      });
    },
    diff: {
      startResourceDiffJob,
      getResourceDiffJob,
    },
    name: EhrName.Canvas,
  };

  return (
    <Box>
      <SharedStateProvider
        authToken={state.authToken}
        baseUrl={ossBaseUrlCanvas}
        ehrDetails={ehrDetails}
        featureFlags={state.featureFlags}
      >
        {state.featureFlags.shouldShowLegacyDashV1 ? (
          <PatientOverview patientId={ehrPatientId} />
        ) : (
          // after v1 code is removed, remove ehrDetails from SharedStateProvider ^!
          <EhrProvider patientId={ehrPatientId} ehrDetails={ehrDetails}>
            <PatientOverviewV2 patientId={ehrPatientId} />
          </EhrProvider>
        )}
      </SharedStateProvider>
    </Box>
  );
}
